/* OptionAnalysis.jsx — On-demand option chain analysis panel */

function fmtOI(n) {
  if (n == null) return '--';
  if (n === 0) return '0';
  if (Math.abs(n) >= 1e7) return (n / 1e7).toFixed(2) + 'Cr';
  if (Math.abs(n) >= 1e5) return (n / 1e5).toFixed(2) + 'L';
  if (Math.abs(n) >= 1e3) return (n / 1e3).toFixed(1) + 'K';
  return n.toLocaleString();
}
function fmtNum(n, dec) { if (n == null) return '--'; return Number(n).toFixed(dec || 2); }

function analyze(chain, spot) {
  if (!chain || !chain.length || !spot) return null;

  // ── Basic aggregates ──
  var totalCEOI = 0, totalPEOI = 0, totalCEVol = 0, totalPEVol = 0;
  var totalCEOIChg = 0, totalPEOIChg = 0, ceOIChgCount = 0, peOIChgCount = 0;
  chain.forEach(function(r) {
    totalCEOI += (r.ce_oi || 0);
    totalPEOI += (r.pe_oi || 0);
    totalCEVol += (r.ce_volume || 0);
    totalPEVol += (r.pe_volume || 0);
    if (r.ce_oi_change != null) { totalCEOIChg += r.ce_oi_change; ceOIChgCount++; }
    if (r.pe_oi_change != null) { totalPEOIChg += r.pe_oi_change; peOIChgCount++; }
  });

  var pcrOI = totalCEOI > 0 ? totalPEOI / totalCEOI : 0;
  var pcrVol = totalCEVol > 0 ? totalPEVol / totalCEVol : 0;

  // ── Max Pain ──
  var maxPainStrike = null, minPain = Infinity;
  chain.forEach(function(row) {
    var pain = 0;
    chain.forEach(function(r) {
      if (r.ce_oi && r.strike < row.strike) pain += r.ce_oi * (row.strike - r.strike);
      if (r.pe_oi && r.strike > row.strike) pain += r.pe_oi * (r.strike - row.strike);
    });
    if (pain < minPain) { minPain = pain; maxPainStrike = row.strike; }
  });

  // ── ATM ──
  var atmRow = chain.reduce(function(best, r) {
    return Math.abs(r.strike - spot) < Math.abs(best.strike - spot) ? r : best;
  }, chain[0]);

  // ── Straddle price (expected move) ──
  var atmCELTP = atmRow.ce_ltp || 0;
  var atmPELTP = atmRow.pe_ltp || 0;
  var straddlePrice = atmCELTP + atmPELTP;
  var expectedMovePct = spot > 0 ? (straddlePrice / spot * 100) : 0;
  var upperRange = spot + straddlePrice;
  var lowerRange = spot - straddlePrice;

  // ── ATM IV ──
  var atmCEIV = atmRow.ce_iv || null;
  var atmPEIV = atmRow.pe_iv || null;
  var atmAvgIV = (atmCEIV && atmPEIV) ? (atmCEIV + atmPEIV) / 2 : (atmCEIV || atmPEIV || null);
  var ivSkew = (atmCEIV && atmPEIV) ? atmCEIV - atmPEIV : null;

  // ── Highest OI strikes (support/resistance) ──
  var highestCEOI = { strike: 0, oi: 0 };
  var highestPEOI = { strike: 0, oi: 0 };
  var top3CEOI = [], top3PEOI = [];

  chain.forEach(function(r) {
    if ((r.ce_oi || 0) > highestCEOI.oi) highestCEOI = { strike: r.strike, oi: r.ce_oi };
    if ((r.pe_oi || 0) > highestPEOI.oi) highestPEOI = { strike: r.strike, oi: r.pe_oi };
  });

  top3CEOI = chain.slice().sort(function(a, b) { return (b.ce_oi || 0) - (a.ce_oi || 0); }).slice(0, 3);
  top3PEOI = chain.slice().sort(function(a, b) { return (b.pe_oi || 0) - (a.pe_oi || 0); }).slice(0, 3);

  // ── OI Change analysis — where is money flowing ──
  var topCEOIBuildup = chain.slice().sort(function(a, b) { return (b.ce_oi_chg || 0) - (a.ce_oi_chg || 0); }).slice(0, 3).filter(function(r) { return (r.ce_oi_chg || 0) > 0; });
  var topPEOIBuildup = chain.slice().sort(function(a, b) { return (b.pe_oi_chg || 0) - (a.pe_oi_chg || 0); }).slice(0, 3).filter(function(r) { return (r.pe_oi_chg || 0) > 0; });
  var topCEOIUnwind = chain.slice().sort(function(a, b) { return (a.ce_oi_chg || 0) - (b.ce_oi_chg || 0); }).slice(0, 3).filter(function(r) { return (r.ce_oi_chg || 0) < 0; });
  var topPEOIUnwind = chain.slice().sort(function(a, b) { return (a.pe_oi_chg || 0) - (b.pe_oi_chg || 0); }).slice(0, 3).filter(function(r) { return (r.pe_oi_chg || 0) < 0; });

  // ── IV distribution ──
  var ivAboveATM = [], ivBelowATM = [];
  chain.forEach(function(r) {
    if (r.strike > spot && r.ce_iv) ivAboveATM.push(r.ce_iv);
    if (r.strike < spot && r.pe_iv) ivBelowATM.push(r.pe_iv);
  });
  var avgIVAbove = ivAboveATM.length ? ivAboveATM.reduce(function(a, b) { return a + b; }, 0) / ivAboveATM.length : null;
  var avgIVBelow = ivBelowATM.length ? ivBelowATM.reduce(function(a, b) { return a + b; }, 0) / ivBelowATM.length : null;

  // ── Net OI change sentiment ──
  var netOIChgSentiment = 'NEUTRAL';
  if (ceOIChgCount > 0 && peOIChgCount > 0) {
    if (totalPEOIChg > totalCEOIChg && totalPEOIChg > 0) netOIChgSentiment = 'BULLISH';
    else if (totalCEOIChg > totalPEOIChg && totalCEOIChg > 0) netOIChgSentiment = 'BEARISH';
  }

  // ── Spot distance from key levels ──
  var distFromResistance = highestCEOI.strike ? ((highestCEOI.strike - spot) / spot * 100) : null;
  var distFromSupport = highestPEOI.strike ? ((spot - highestPEOI.strike) / spot * 100) : null;
  var distFromMaxPain = maxPainStrike ? ((maxPainStrike - spot) / spot * 100) : null;

  // ── Build verdict ──
  var signals = [];
  // PCR
  if (pcrOI > 1.3) signals.push({ type: 'BULLISH', strength: 2, reason: 'PCR ' + pcrOI.toFixed(2) + ' (high PE writing \u2192 support)' });
  else if (pcrOI > 1.0) signals.push({ type: 'BULLISH', strength: 1, reason: 'PCR ' + pcrOI.toFixed(2) + ' (moderately bullish)' });
  else if (pcrOI < 0.7) signals.push({ type: 'BEARISH', strength: 2, reason: 'PCR ' + pcrOI.toFixed(2) + ' (heavy CE writing \u2192 resistance)' });
  else if (pcrOI < 1.0) signals.push({ type: 'BEARISH', strength: 1, reason: 'PCR ' + pcrOI.toFixed(2) + ' (moderately bearish)' });

  // Max pain position
  if (maxPainStrike && spot) {
    var mpDist = Math.round(maxPainStrike - spot);
    var mpPct = Math.abs(mpDist / spot * 100).toFixed(1);
    if (spot > maxPainStrike * 1.005) signals.push({ type: 'BEARISH', strength: 1, reason: 'Spot ' + Math.abs(mpDist) + 'pts ABOVE Max Pain ' + maxPainStrike + ' (' + mpPct + '%) \u2192 pull down likely' });
    else if (spot < maxPainStrike * 0.995) signals.push({ type: 'BULLISH', strength: 1, reason: 'Spot ' + Math.abs(mpDist) + 'pts BELOW Max Pain ' + maxPainStrike + ' (' + mpPct + '%) \u2192 pull up likely' });
    else signals.push({ type: 'NEUTRAL', strength: 1, reason: 'Spot at Max Pain ' + maxPainStrike + ' (\u00B1' + Math.abs(mpDist) + 'pts) \u2192 range-bound likely' });
  }

  // OI change sentiment
  if (netOIChgSentiment === 'BULLISH') signals.push({ type: 'BULLISH', strength: 1, reason: 'Net PE OI building > CE OI \u2192 writers expect support' });
  else if (netOIChgSentiment === 'BEARISH') signals.push({ type: 'BEARISH', strength: 1, reason: 'Net CE OI building > PE OI \u2192 writers expect resistance' });

  // CE unwinding = short covering = bullish
  if (totalCEOIChg < -100000) signals.push({ type: 'BULLISH', strength: 1, reason: 'CE OI unwinding (' + fmtOI(totalCEOIChg) + ') \u2192 short covering' });
  // PE unwinding = long unwinding = bearish
  if (totalPEOIChg < -100000) signals.push({ type: 'BEARISH', strength: 1, reason: 'PE OI unwinding (' + fmtOI(totalPEOIChg) + ') \u2192 long unwinding' });

  // Straddle / expected range
  if (straddlePrice > 0 && expectedMovePct < 1.5) signals.push({ type: 'NEUTRAL', strength: 1, reason: 'Low straddle premium (' + fmtNum(expectedMovePct, 1) + '%) \u2192 low volatility expected' });
  else if (expectedMovePct > 3) signals.push({ type: 'NEUTRAL', strength: 1, reason: 'High straddle premium (' + fmtNum(expectedMovePct, 1) + '%) \u2192 big move expected' });

  // IV skew (ATM)
  if (ivSkew !== null) {
    if (ivSkew > 3) signals.push({ type: 'BULLISH', strength: 1, reason: 'CE IV > PE IV by ' + fmtNum(ivSkew, 1) + '% \u2192 call demand/upside expectation' });
    else if (ivSkew < -3) signals.push({ type: 'BEARISH', strength: 1, reason: 'PE IV > CE IV by ' + fmtNum(Math.abs(ivSkew), 1) + '% \u2192 downside fear/put demand' });
  }

  // OTM IV skew (wider picture)
  if (avgIVAbove && avgIVBelow) {
    var otmSkew = avgIVBelow - avgIVAbove;
    if (otmSkew > 5) signals.push({ type: 'BEARISH', strength: 1, reason: 'OTM PE IV (' + fmtNum(avgIVBelow, 1) + '%) > OTM CE IV (' + fmtNum(avgIVAbove, 1) + '%) by ' + fmtNum(otmSkew, 1) + '% \u2192 heavy put skew' });
    else if (otmSkew < -5) signals.push({ type: 'BULLISH', strength: 1, reason: 'OTM CE IV (' + fmtNum(avgIVAbove, 1) + '%) > OTM PE IV (' + fmtNum(avgIVBelow, 1) + '%) by ' + fmtNum(Math.abs(otmSkew), 1) + '% \u2192 heavy call skew' });
  }

  // Support/Resistance proximity
  if (distFromResistance !== null && distFromResistance < 0.5 && distFromResistance > 0) {
    signals.push({ type: 'BEARISH', strength: 2, reason: 'Spot near highest CE OI ' + highestCEOI.strike + ' (' + fmtNum(distFromResistance, 1) + '% away) \u2192 strong resistance' });
  }
  if (distFromSupport !== null && distFromSupport < 0.5 && distFromSupport > 0) {
    signals.push({ type: 'BULLISH', strength: 2, reason: 'Spot near highest PE OI ' + highestPEOI.strike + ' (' + fmtNum(distFromSupport, 1) + '% away) \u2192 strong support' });
  }

  // Overall verdict
  var bullScore = 0, bearScore = 0;
  signals.forEach(function(s) {
    if (s.type === 'BULLISH') bullScore += s.strength;
    else if (s.type === 'BEARISH') bearScore += s.strength;
  });
  var verdict = 'NEUTRAL';
  var verdictColor = '#fbbf24';
  if (bullScore >= bearScore + 3) { verdict = 'STRONGLY BULLISH'; verdictColor = '#00d4aa'; }
  else if (bullScore >= bearScore + 1) { verdict = 'MILDLY BULLISH'; verdictColor = '#4ade80'; }
  else if (bearScore >= bullScore + 3) { verdict = 'STRONGLY BEARISH'; verdictColor = '#ff4466'; }
  else if (bearScore >= bullScore + 1) { verdict = 'MILDLY BEARISH'; verdictColor = '#f87171'; }

  return {
    pcrOI: pcrOI, pcrVol: pcrVol,
    maxPainStrike: maxPainStrike,
    atmRow: atmRow, straddlePrice: straddlePrice,
    expectedMovePct: expectedMovePct,
    upperRange: upperRange, lowerRange: lowerRange,
    atmCEIV: atmCEIV, atmPEIV: atmPEIV, atmAvgIV: atmAvgIV, ivSkew: ivSkew,
    avgIVAbove: avgIVAbove, avgIVBelow: avgIVBelow,
    otmIVSkew: (avgIVAbove && avgIVBelow) ? (avgIVBelow - avgIVAbove) : null,
    highestCEOI: highestCEOI, highestPEOI: highestPEOI,
    top3CEOI: top3CEOI, top3PEOI: top3PEOI,
    topCEOIBuildup: topCEOIBuildup, topPEOIBuildup: topPEOIBuildup,
    topCEOIUnwind: topCEOIUnwind, topPEOIUnwind: topPEOIUnwind,
    totalCEOI: totalCEOI, totalPEOI: totalPEOI,
    totalCEVol: totalCEVol, totalPEVol: totalPEVol,
    totalCEOIChg: totalCEOIChg, totalPEOIChg: totalPEOIChg,
    netOIChgSentiment: netOIChgSentiment,
    distFromResistance: distFromResistance, distFromSupport: distFromSupport,
    distFromMaxPain: distFromMaxPain,
    signals: signals,
    verdict: verdict, verdictColor: verdictColor,
    bullScore: bullScore, bearScore: bearScore,
    spot: spot,
  };
}

export default function OptionAnalysis({ chain, spot, onClose }) {
  var a = analyze(chain, spot);

  if (!a) {
    return (
      <div style={{ padding: 20, textAlign: 'center', color: '#556677', fontSize: 12 }}>
        No data available for analysis. Load the option chain first.
      </div>
    );
  }

  var sectionStyle = { padding: '10px 14px', borderBottom: '1px solid rgba(26,45,74,0.3)' };
  var labelStyle = { fontSize: 9, color: '#556677', fontWeight: 800, letterSpacing: '0.5px', marginBottom: 6, textTransform: 'uppercase' };
  var rowStyle = { display: 'flex', justifyContent: 'space-between', fontSize: 10, marginBottom: 3 };
  var tagBull = { fontSize: 9, fontWeight: 700, padding: '1px 5px', borderRadius: 2, background: 'rgba(0,212,170,0.1)', color: '#00d4aa', border: '1px solid rgba(0,212,170,0.2)' };
  var tagBear = { fontSize: 9, fontWeight: 700, padding: '1px 5px', borderRadius: 2, background: 'rgba(255,68,102,0.1)', color: '#ff4466', border: '1px solid rgba(255,68,102,0.2)' };
  var tagNeutral = { fontSize: 9, fontWeight: 700, padding: '1px 5px', borderRadius: 2, background: 'rgba(251,191,36,0.1)', color: '#fbbf24', border: '1px solid rgba(251,191,36,0.2)' };

  function getTag(type) { return type === 'BULLISH' ? tagBull : type === 'BEARISH' ? tagBear : tagNeutral; }

  return (
    <div style={{ background: '#070c1b', borderBottom: '2px solid rgba(14,165,233,0.3)', maxHeight: 420, overflowY: 'auto', fontFamily: "'Inter', sans-serif" }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 14px', background: '#0a0f1e', borderBottom: '1px solid rgba(26,45,74,0.4)' }}>
        <span style={{ fontSize: 11, fontWeight: 800, color: '#0ea5e9', letterSpacing: '0.5px' }}>{'\uD83D\uDCCA'} OPTION CHAIN ANALYSIS</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 10, color: '#556677' }}>Spot: {fmtNum(a.spot)}</span>
          <button onClick={onClose} style={{ background: 'none', border: '1px solid rgba(100,100,120,0.3)', borderRadius: 3, color: '#556677', cursor: 'pointer', padding: '2px 8px', fontSize: 9, fontFamily: 'inherit' }}>{'\u2715'} Close</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 0 }}>

        {/* ── Column 1: Verdict + Key Levels ── */}
        <div style={{ borderRight: '1px solid rgba(26,45,74,0.3)' }}>

          {/* Verdict */}
          <div style={sectionStyle}>
            <div style={labelStyle}>VERDICT</div>
            <div style={{ fontSize: 16, fontWeight: 900, color: a.verdictColor, marginBottom: 4 }}>{a.verdict}</div>
            <div style={{ display: 'flex', gap: 8, fontSize: 10 }}>
              <span style={{ color: '#00d4aa' }}>{'\u25B2'} Bull: {a.bullScore}</span>
              <span style={{ color: '#ff4466' }}>{'\u25BC'} Bear: {a.bearScore}</span>
            </div>
          </div>

          {/* Key Levels */}
          <div style={sectionStyle}>
            <div style={labelStyle}>KEY LEVELS</div>
            <div style={rowStyle}>
              <span style={{ color: '#ff4466' }}>Resistance (CE OI)</span>
              <span style={{ color: '#e2e8f0', fontWeight: 700 }}>{a.highestCEOI.strike} <span style={{ color: '#556677', fontWeight: 400 }}>({fmtOI(a.highestCEOI.oi)})</span></span>
            </div>
            <div style={rowStyle}>
              <span style={{ color: '#fbbf24' }}>Max Pain</span>
              <span style={{ color: '#e2e8f0', fontWeight: 700 }}>{a.maxPainStrike}</span>
            </div>
            <div style={rowStyle}>
              <span style={{ color: '#0ea5e9' }}>Spot</span>
              <span style={{ color: '#e2e8f0', fontWeight: 700 }}>{fmtNum(a.spot)}</span>
            </div>
            <div style={rowStyle}>
              <span style={{ color: '#00d4aa' }}>Support (PE OI)</span>
              <span style={{ color: '#e2e8f0', fontWeight: 700 }}>{a.highestPEOI.strike} <span style={{ color: '#556677', fontWeight: 400 }}>({fmtOI(a.highestPEOI.oi)})</span></span>
            </div>
            {/* Visual bar */}
            <div style={{ marginTop: 6, height: 6, background: 'rgba(255,255,255,0.03)', borderRadius: 3, position: 'relative', overflow: 'hidden' }}>
              {a.highestPEOI.strike && a.highestCEOI.strike && (function() {
                var range = a.highestCEOI.strike - a.highestPEOI.strike;
                if (range <= 0) return null;
                var spotPct = ((a.spot - a.highestPEOI.strike) / range) * 100;
                var mpPct = a.maxPainStrike ? ((a.maxPainStrike - a.highestPEOI.strike) / range) * 100 : null;
                return (
                  <>
                    <div style={{ position: 'absolute', left: 0, top: 0, height: '100%', width: '50%', background: 'linear-gradient(90deg, rgba(0,212,170,0.3), transparent)' }} />
                    <div style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '50%', background: 'linear-gradient(270deg, rgba(255,68,102,0.3), transparent)' }} />
                    <div style={{ position: 'absolute', left: Math.max(0, Math.min(100, spotPct)) + '%', top: -1, width: 2, height: 8, background: '#0ea5e9', borderRadius: 1 }} title="Spot" />
                    {mpPct !== null && <div style={{ position: 'absolute', left: Math.max(0, Math.min(100, mpPct)) + '%', top: -1, width: 2, height: 8, background: '#fbbf24', borderRadius: 1 }} title="Max Pain" />}
                  </>
                );
              })()}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 8, color: '#3d4f63', marginTop: 2 }}>
              <span>{a.highestPEOI.strike} (S)</span>
              <span>{a.highestCEOI.strike} (R)</span>
            </div>
          </div>

          {/* Expected Range */}
          <div style={sectionStyle}>
            <div style={labelStyle}>EXPECTED RANGE (Straddle)</div>
            <div style={rowStyle}>
              <span style={{ color: '#556677' }}>ATM Straddle</span>
              <span style={{ color: '#e2e8f0', fontWeight: 700 }}>{'\u20B9'}{fmtNum(a.straddlePrice)} ({fmtNum(a.expectedMovePct, 1)}%)</span>
            </div>
            <div style={rowStyle}>
              <span style={{ color: '#00d4aa' }}>Upper</span>
              <span style={{ color: '#e2e8f0' }}>{fmtNum(a.upperRange)}</span>
            </div>
            <div style={rowStyle}>
              <span style={{ color: '#ff4466' }}>Lower</span>
              <span style={{ color: '#e2e8f0' }}>{fmtNum(a.lowerRange)}</span>
            </div>
          </div>
        </div>

        {/* ── Column 2: OI Analysis ── */}
        <div style={{ borderRight: '1px solid rgba(26,45,74,0.3)' }}>

          {/* PCR */}
          <div style={sectionStyle}>
            <div style={labelStyle}>PUT-CALL RATIO</div>
            <div style={rowStyle}>
              <span style={{ color: '#556677' }}>PCR (OI)</span>
              <span style={{ color: a.pcrOI > 1 ? '#00d4aa' : '#ff4466', fontWeight: 700 }}>{fmtNum(a.pcrOI)}
                <span style={a.pcrOI > 1 ? tagBull : tagBear}> {a.pcrOI > 1.3 ? 'BULLISH' : a.pcrOI > 1 ? 'MILD BULL' : a.pcrOI < 0.7 ? 'BEARISH' : 'MILD BEAR'}</span>
              </span>
            </div>
            <div style={rowStyle}>
              <span style={{ color: '#556677' }}>PCR (Volume)</span>
              <span style={{ color: '#8899aa' }}>{fmtNum(a.pcrVol)}</span>
            </div>
            <div style={rowStyle}>
              <span style={{ color: '#ff4466' }}>Total CE OI</span>
              <span style={{ color: '#c4cfd8' }}>{fmtOI(a.totalCEOI)}</span>
            </div>
            <div style={rowStyle}>
              <span style={{ color: '#00d4aa' }}>Total PE OI</span>
              <span style={{ color: '#c4cfd8' }}>{fmtOI(a.totalPEOI)}</span>
            </div>
          </div>

          {/* Top OI Strikes */}
          <div style={sectionStyle}>
            <div style={labelStyle}>TOP CE OI (Resistance)</div>
            {a.top3CEOI.map(function(r, i) {
              return <div key={i} style={rowStyle}><span style={{ color: '#ff4466' }}>{r.strike}</span><span style={{ color: '#c4cfd8' }}>{fmtOI(r.ce_oi)}</span></div>;
            })}
          </div>

          <div style={sectionStyle}>
            <div style={labelStyle}>TOP PE OI (Support)</div>
            {a.top3PEOI.map(function(r, i) {
              return <div key={i} style={rowStyle}><span style={{ color: '#00d4aa' }}>{r.strike}</span><span style={{ color: '#c4cfd8' }}>{fmtOI(r.pe_oi)}</span></div>;
            })}
          </div>

          {/* OI Change Flow */}
          <div style={sectionStyle}>
            <div style={labelStyle}>OI CHANGE FLOW <span style={getTag(a.netOIChgSentiment)}>{a.netOIChgSentiment}</span></div>
            <div style={rowStyle}><span style={{ color: '#ff4466' }}>CE OI Change</span><span style={{ color: a.totalCEOIChg >= 0 ? '#4ade80' : '#f87171', fontWeight: 700 }}>{a.totalCEOIChg > 0 ? '+' : ''}{fmtOI(a.totalCEOIChg)}</span></div>
            <div style={rowStyle}><span style={{ color: '#00d4aa' }}>PE OI Change</span><span style={{ color: a.totalPEOIChg >= 0 ? '#4ade80' : '#f87171', fontWeight: 700 }}>{a.totalPEOIChg > 0 ? '+' : ''}{fmtOI(a.totalPEOIChg)}</span></div>
          </div>
        </div>

        {/* ── Column 3: IV + OI Buildup + Signals ── */}
        <div>

          {/* IV */}
          <div style={sectionStyle}>
            <div style={labelStyle}>IMPLIED VOLATILITY</div>
            <div style={rowStyle}><span style={{ color: '#556677' }}>ATM CE IV</span><span style={{ color: '#ff8866' }}>{a.atmCEIV ? fmtNum(a.atmCEIV, 1) + '%' : '--'}</span></div>
            <div style={rowStyle}><span style={{ color: '#556677' }}>ATM PE IV</span><span style={{ color: '#66ccaa' }}>{a.atmPEIV ? fmtNum(a.atmPEIV, 1) + '%' : '--'}</span></div>
            <div style={rowStyle}><span style={{ color: '#556677' }}>ATM Avg IV</span><span style={{ color: '#e2e8f0', fontWeight: 700 }}>{a.atmAvgIV ? fmtNum(a.atmAvgIV, 1) + '%' : '--'}</span></div>
            <div style={rowStyle}><span style={{ color: '#556677' }}>IV Skew (CE-PE)</span><span style={{ color: a.ivSkew > 0 ? '#00d4aa' : a.ivSkew < 0 ? '#ff4466' : '#8899aa', fontWeight: 700 }}>{a.ivSkew != null ? (a.ivSkew > 0 ? '+' : '') + fmtNum(a.ivSkew, 1) + '%' : '--'}</span></div>
            {a.avgIVAbove && <div style={rowStyle}><span style={{ color: '#556677' }}>Avg IV (OTM CE)</span><span style={{ color: '#8899aa' }}>{fmtNum(a.avgIVAbove, 1)}%</span></div>}
            {a.avgIVBelow && <div style={rowStyle}><span style={{ color: '#556677' }}>Avg IV (OTM PE)</span><span style={{ color: '#8899aa' }}>{fmtNum(a.avgIVBelow, 1)}%</span></div>}
            {a.otmIVSkew != null && <div style={rowStyle}><span style={{ color: '#556677' }}>OTM Skew (PE-CE)</span><span style={{ color: a.otmIVSkew > 3 ? '#ff4466' : a.otmIVSkew < -3 ? '#00d4aa' : '#8899aa', fontWeight: 700 }}>{(a.otmIVSkew > 0 ? '+' : '') + fmtNum(a.otmIVSkew, 1)}%</span></div>}
          </div>

          {/* OI Buildup */}
          {(a.topCEOIBuildup.length > 0 || a.topPEOIBuildup.length > 0) && (
            <div style={sectionStyle}>
              <div style={labelStyle}>OI BUILDUP (New Positions)</div>
              {a.topCEOIBuildup.map(function(r, i) {
                return <div key={'cb' + i} style={rowStyle}><span style={{ color: '#ff4466' }}>CE {r.strike}</span><span style={{ color: '#4ade80' }}>+{fmtOI(r.ce_oi_chg)}</span></div>;
              })}
              {a.topPEOIBuildup.map(function(r, i) {
                return <div key={'pb' + i} style={rowStyle}><span style={{ color: '#00d4aa' }}>PE {r.strike}</span><span style={{ color: '#4ade80' }}>+{fmtOI(r.pe_oi_chg)}</span></div>;
              })}
            </div>
          )}

          {/* OI Unwinding */}
          {(a.topCEOIUnwind.length > 0 || a.topPEOIUnwind.length > 0) && (
            <div style={sectionStyle}>
              <div style={labelStyle}>OI UNWINDING (Closing Positions)</div>
              {a.topCEOIUnwind.map(function(r, i) {
                return <div key={'cu' + i} style={rowStyle}><span style={{ color: '#ff4466' }}>CE {r.strike}</span><span style={{ color: '#f87171' }}>{fmtOI(r.ce_oi_chg)}</span></div>;
              })}
              {a.topPEOIUnwind.map(function(r, i) {
                return <div key={'pu' + i} style={rowStyle}><span style={{ color: '#00d4aa' }}>PE {r.strike}</span><span style={{ color: '#f87171' }}>{fmtOI(r.pe_oi_chg)}</span></div>;
              })}
            </div>
          )}

          {/* All Signals */}
          <div style={sectionStyle}>
            <div style={labelStyle}>SIGNAL BREAKDOWN</div>
            {a.signals.map(function(s, i) {
              return (
                <div key={i} style={{ display: 'flex', gap: 6, marginBottom: 4, alignItems: 'flex-start' }}>
                  <span style={getTag(s.type)}>{s.type === 'BULLISH' ? '\u25B2' : s.type === 'BEARISH' ? '\u25BC' : '\u25C6'}</span>
                  <span style={{ fontSize: 9, color: '#8899aa', lineHeight: '14px' }}>{s.reason}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
